import { toast } from 'sonner';
import { fetchChainDetails, getMetaMaskProvider } from '../blockchainInteraction/finaliseGrading';

export const colors = {
    Water: {
        text: 'text-[#76C8E8]',
    },
    Earth: {
        text: 'text-[#36B67A]',
    },
    Energy: {
        text: 'text-[#FBCF4E]',
    },
    Social: {
        text: 'text-[#ED1F1F]',
    },
};

export const fundText = {
    red: {
        // text: "text-[#EFD1D1]",
        text: 'text-[#B33030]',
        progress: 'bg-[#B33030]',
        perFundText: 'text-[#EB9E9E]',
        image: 1,
    },

    green: {
        // text: "text-[#D1EFE0]",
        text: 'text-[#287950]',
        progress: 'bg-[#287950]',
        perFundText: 'text-[#D1EFE0]',
        image: 4,
    },
    yellow: {
        // text: "text-[#EFE5D1]",
        text: 'text-[#EBD29E]',
        progress: 'bg-[#C09536]',
        perFundText: 'text-[#EBD29E]',
        image: 3,
    },
};

export const getImage = (n) => {
    if (Number(isNaN(n))) {
        return 1;
    }
    if (!n) return 1;
    if (n < 50) return 1;
    else if (n < 100) return 3;
    else if (n === 100) return 4;
};

export const getColor = (n) => {
    if (Number(isNaN(n))) {
        return 'red';
    }
    if (n < 1260) return 'red';
    else if (n < 2520) return 'yellow';
    else return 'green';
};

export const extraIPsNotification = {
    first: {
        operation: 'mint',
        text: 'Mint a greenpill NFT now to tokenize your real world impact',
    },
    second: {
        operation: 'tokenize',
        text: 'Select a primary pill to direct all your points and tokenize your real world impact',
    },
    third: {
        operation: 'mint',
        extraText: 'but your NFT is fully transformed',
        text: 'Mint a new NFT to direct all your points and tokenize your real world impact',
    },
    fourth: {
        operation: 'mint',
        text: 'Set another pill as your primary pill to direct all your points and tokenize your real world impact',
    },
};

export const getNotificationNumber = (nfts, totalGreenNFTs, isPrimaryPill) => {
    console.log(nfts, 'nfts in helper');

    console.log('nfts in helper');

    if (nfts.length === 0) {
        return 'first';
    } else if (nfts?.length > 0 && !isPrimaryPill) {
        return 'second';
    } else if (totalGreenNFTs === nfts.length) {
        return 'third';
    } else {
        return 'fourth';
    }
};

export const phantomConnection = async (linkedWallet, wallet) => {
    try {
        const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');

        if (!phantom || !phantom.adapter) {
            toast.error('Phantom wallet not found');
            return 'chainerror';
        }

        // Select Phantom wallet if not already selected
        if (phantom.adapter?.name !== 'Phantom') {
            await wallet.select(phantom.adapter.name);
        }

        // Disconnect if already connected
        if (phantom.adapter.connected) {
            await phantom.adapter.disconnect();
        }

        // Now connect to Phantom
        await phantom.adapter.connect();

        const publicKey = phantom.adapter.publicKey;
        if (!publicKey) {
            toast.error('Failed to get Phantom wallet address');
            return 'chainerror';
        }

        const newWallet = publicKey.toBase58()?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

        if (existingWallet && newWallet !== existingWallet) {
            return undefined;
        } else if (!existingWallet) {
            return { text: 'changewallet', wallet: publicKey.toBase58() };
        } else {
            console.log('returned');
            return publicKey.toBase58();
        }
    } catch (error) {
        toast.error('Error connecting to Phantom wallet');
        return 'chainerror';
    }
};


export const metaConnectionProjectIc = async (linkedWallet, chainId) => {
    const metaMaskProvider = getMetaMaskProvider();

    if (!metaMaskProvider) {
        const installUrl = 'https://metamask.io/download.html';
        toast.info('Opening MetaMask installation page in a new tab...');
        window.open(installUrl, '_blank');
        return;
    }

    try {
        // Always prompt MetaMask popup
        const accounts = await metaMaskProvider.request({
            method: 'wallet_requestPermissions',
            params: [{ eth_accounts: {} }],
        });

        // Now explicitly request selected accounts again
        const selectedAccounts = await metaMaskProvider.request({
            method: 'eth_requestAccounts',
        });

        if (!selectedAccounts || selectedAccounts.length === 0) {
            toast.error('No wallet selected. Connection cancelled.');
            return;
        }

        const newWallet = selectedAccounts[0]?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

       
            const userChainId = await metaMaskProvider.request({
                method: 'eth_chainId',
            });
            const targetChainId = `0x${parseInt(chainId, 10).toString(16)}`; // Convert to hex string

            if (userChainId !== targetChainId) {
                try {
                    // Attempt to switch to the correct chain
                    await metaMaskProvider.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: targetChainId }],
                    });
                    toast.success(`Switched to chain ID: ${targetChainId}`);
                } catch (switchError) {
                    // Handle the case where the chain is not added or user rejects the switch

                    if (switchError.code === 4902) {
                        // 4902: Chain not added to MetaMask
                        try {
                            const chainDetails = await fetchChainDetails(chainId);
                            await metaMaskProvider.request({
                                method: 'wallet_addEthereumChain',
                                params: [chainDetails],
                            });
                            toast.success(`Added and switched to chain ID: ${targetChainId}`);
                        } catch (addError) {
                            toast.error('Failed to add or switch to the required chain');
                            return 'chainerror';
                        }
                    } else {
                        toast.error('Please change your chain network manually');
                        return 'chainerror';
                    }
                }
            }

            return selectedAccounts[0];
        
    } catch (error) {
        console.error('MetaMask connection error:', error);
        toast.error('Failed to connect MetaMask wallet.');
        return 'chainerror';
    }
};


export const metaConnection = async (linkedWallet, chainId) => {
    const metaMaskProvider = getMetaMaskProvider();

    if (!metaMaskProvider) {
        const installUrl = 'https://metamask.io/download.html';
        toast.info('Opening MetaMask installation page in a new tab...');
        window.open(installUrl, '_blank');
        return;
    }

    try {
        // Always prompt MetaMask popup
        const accounts = await metaMaskProvider.request({
            method: 'wallet_requestPermissions',
            params: [{ eth_accounts: {} }],
        });

        // Now explicitly request selected accounts again
        const selectedAccounts = await metaMaskProvider.request({
            method: 'eth_requestAccounts',
        });

        if (!selectedAccounts || selectedAccounts.length === 0) {
            toast.error('No wallet selected. Connection cancelled.');
            return;
        }

        const newWallet = selectedAccounts[0]?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

        if (existingWallet && newWallet !== existingWallet) {
            return undefined;
        } else if (!existingWallet) {
            return { text: 'changewallet', wallet: selectedAccounts[0] };
        } else {
            const userChainId = await metaMaskProvider.request({
                method: 'eth_chainId',
            });
            const targetChainId = `0x${parseInt(chainId, 10).toString(16)}`; // Convert to hex string

            if (userChainId !== targetChainId) {
                try {
                    // Attempt to switch to the correct chain
                    await metaMaskProvider.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: targetChainId }],
                    });
                    toast.success(`Switched to chain ID: ${targetChainId}`);
                } catch (switchError) {
                    // Handle the case where the chain is not added or user rejects the switch

                    if (switchError.code === 4902) {
                        // 4902: Chain not added to MetaMask
                        try {
                            const chainDetails = await fetchChainDetails(chainId);
                            await metaMaskProvider.request({
                                method: 'wallet_addEthereumChain',
                                params: [chainDetails],
                            });
                            toast.success(`Added and switched to chain ID: ${targetChainId}`);
                        } catch (addError) {
                            toast.error('Failed to add or switch to the required chain');
                            return 'chainerror';
                        }
                    } else {
                        toast.error('Please change your chain network manually');
                        return 'chainerror';
                    }
                }
            }

            return selectedAccounts[0];
        }
    } catch (error) {
        console.error('MetaMask connection error:', error);
        toast.error('Failed to connect MetaMask wallet.');
        return 'chainerror';
    }
};
